module.exports = __webpack_public_path__ + "static/logo-52b16038abba021992919376d04edbd9.png";